import { FC } from 'react';

type Props = {
	className?: string;
};

const DashboardCircleIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.668 6.16667C10.668 4.41777 12.0857 3 13.8346 3C15.5836 3 17.0013 4.41777 17.0013 6.16667C17.0013 7.91558 15.5836 9.33335 13.8346 9.33335C12.0857 9.33335 10.668 7.91558 10.668 6.16667Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3 6.16667C3 4.41777 4.41777 3 6.16667 3C7.91558 3 9.33335 4.41777 9.33335 6.16667C9.33335 7.91558 7.91558 9.33335 6.16667 9.33335C4.41777 9.33335 3 7.91558 3 6.16667Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.668 13.8337C10.668 12.0847 12.0857 10.667 13.8346 10.667C15.5836 10.667 17.0013 12.0847 17.0013 13.8337C17.0013 15.5826 15.5836 17.0003 13.8346 17.0003C12.0857 17.0003 10.668 15.5826 10.668 13.8337Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3 13.8337C3 12.0847 4.41777 10.667 6.16667 10.667C7.91558 10.667 9.33335 12.0847 9.33335 13.8337C9.33335 15.5826 7.91558 17.0003 6.16667 17.0003C4.41777 17.0003 3 15.5826 3 13.8337Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default DashboardCircleIconSolid;
